import React, { useState } from 'react'
import {
  Modal,
  Box,
  Button,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material'

interface Props {
  open: boolean
  onClose: () => void
  onConfirm: (tipo: 'btnGerarLocal' | 'btnGerarOnline') => void
  titulo: string
}

export default function ModalGerarModelo({ open, onClose, onConfirm, titulo }: Props) {
  const [option, setOption] = useState<'btnGerarLocal' | 'btnGerarOnline'>('btnGerarLocal')

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.nativeEvent.isComposing && !(event.target as HTMLElement).closest('button')) {
            event.preventDefault();
            onConfirm(option);
          }
        }}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: '#fff',
          borderRadius: 2,
          boxShadow: '0px 4px 20px rgba(0,0,0,0.15)',
          p: 4,
          width: 420,
          textAlign: 'left',
          '&:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
        }}
      >
        <Typography variant="h6" fontWeight="bold" mb={1}>
          {titulo}
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          Escolha o tipo de geração:
        </Typography>

        <RadioGroup
          value={option}
          onChange={(e) => setOption(e.target.value as 'btnGerarLocal' | 'btnGerarOnline')}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            mb: 4,
            width: '100%',
            '& .MuiFormControlLabel-root': {
              flex: 1,
              margin: 0,
              display: 'flex',
            },
            '& .MuiFormControlLabel-label': {
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #d0d7de',
              borderRadius: '8px',
              padding: '8px 12px',
              textAlign: 'center',
              fontSize: '0.9rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
            },
            '& .MuiRadio-root': {
              display: 'none',
              position: 'absolute',
            },
            '& .Mui-checked + .MuiFormControlLabel-label': {
              borderColor: '#1a3661',
              backgroundColor: '#f0f4ff',
              color: '#1a3661',
              fontWeight: 600,
            },
          }}
        >
          <FormControlLabel
            value="btnGerarLocal"
            control={<Radio />}
            label="Fotos Locais"
          />
          <FormControlLabel
            value="btnGerarOnline"
            control={<Radio />}
            label="Fotos Online"
          />
        </RadioGroup>

        <Box display="flex" justifyContent="space-between" gap={2}>
          <Button
            variant="outlined"
            color="error"
            fullWidth
            sx={{
              borderRadius: '50px',
              textTransform: 'none',
              py: 1,
              fontWeight: '500',
              padding: '6px 16px',
              fontSize: '0.85rem',
            }}
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            autoFocus
            fullWidth
            sx={{
              borderRadius: '50px',
              textTransform: 'none',
              py: 1,
              bgcolor: '#1a3661',
              fontSize: '0.85rem',
              fontWeight: '500',
              padding: '6px 16px',
              '&:hover': { bgcolor: '#15294d' },
            }}
            onClick={() => onConfirm(option)}
          >
            Executar
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
